import { render } from "./SwiftChatDrawer.vue?vue&type=template&id=6395bb5e&scoped=true"
import script from "./SwiftChatDrawer.vue?vue&type=script&lang=js"
export * from "./SwiftChatDrawer.vue?vue&type=script&lang=js"

import "./SwiftChatDrawer.vue?vue&type=style&index=0&id=6395bb5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6395bb5e"]])

export default __exports__